/**
 * Publisher fields whose change must be approved by the agency before it takes
 * effect (per FSD reczech-publishers-fsd.html#PB46). Confirmed by the customer
 * (2026-08-20) as binding and complete: changing anything outside this list
 * (contacts, phone, e-mail, alternative names, roles, mailing address, name
 * suffix, qualifier, …) is saved immediately, without a publisher update
 * (approval) request.
 *
 * `mainAddress` covers the whole registered-seat address — address code, street,
 * postal code and municipality.
 */
export var PUBLISHER_APPROVAL_FIELDS = [
    "companyNumber", // IČO
    "name", // Název
    "legalForm", // Právní forma
    "taxNumber", // DIČ
    "birthDate", // Datum narození
    "mainAddress", // Adresa sídla (kód adresního místa, ulice, PSČ, obec)
    // not listed in FSD PB46, but the backend routes them through the update
    // request as well, so the user must be told they await approval (DB-552)
    "nameSuffix", // Doplněk k názvu
    "qualifier", // Kvalifikátor
    "alternativeNames", // Alternativní názvy
];
export var PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export var DEFAULT_PAGE_SIZE = 20;
export var PAGE_SIZE_STORAGE_KEY = "br-publishers.pageSize";
